import React from 'react';
import { Radio as AntdRadio } from 'antd';
import classNames from 'classnames';
import style from './Radio.module.scss';

interface IProps {
	children: React.ReactNode;
	className?: string;
	checked: boolean;
	disabled?: boolean;
	name?: string;
	testId?: string;
	onChange: () => void;
}

export const Radio: React.FC<IProps> = React.memo(
	({ children, className, checked, disabled = false, name, testId, onChange }) => (
		<AntdRadio
			className={classNames(style.container, className)}
			checked={checked}
			disabled={disabled}
			name={name}
			onChange={onChange}
			data-test={testId}>
			{children}
		</AntdRadio>
	),
);
